import React from "react";
import '../components/custom.css';

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h2 id="header-title">
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h2>
                <p id="paragraph">{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>{" "}
                <p id="theonlineapps">
                <a
                  href="https://www.theonlineapps.com" target="_blank"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Our Online Solutions
                </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
